import moment from "moment";

export default class Controller {
  setFormat(date, interval) {
    switch (interval) {
      case "hourly":
        return moment(date).format("YYYY-MM-DDTHH:mm:ss");
      case "daily":
        return moment(date).format("YYYY-MM-DD");
      case "weekly":
        return moment(date).format("YYYY-MM-DD");
      case "monthly":
        return moment(date).format("YYYY-MM");
      case "yearly":
        return moment(date).format("YYYY");
    }
  }
  setType(interval) {
    let chosenType = "date";
    switch (interval) {
      case "hourly":
        chosenType = "date";
        break;
      case "daily":
        chosenType = "date";
        break;
      case "weekly":
        chosenType = "date";
        break;
      case "monthly":
        chosenType = "month";
        break;
      case "yearly":
        chosenType = "month";
        break;
    }
    return chosenType;
  }
  initialValue(initialDate, interval, range) {
    if (initialDate) return initialDate;
    let startFormat = "YYYY-MM-DD";
    let endFormat = "YYYY-MM-DD";
    switch (interval) {
      case "hourly":
        startFormat = moment().startOf("day").format("YYYY-MM-DDT00:00:00");
        endFormat = moment().endOf("day").format("YYYY-MM-DDT23:59:59");
        break;
      case "daily":
        startFormat = "YYYY-MM-01";
        endFormat = "YYYY-MM-DD";
        break;
      case "weekly":
        startFormat = moment().startOf("week").format("YYYY-MM-DD");
        endFormat = moment().endOf("week").format("YYYY-MM-DD");
        break;
      case "monthly":
        startFormat = "YYYY-01";
        endFormat = "YYYY-MM";
        break;
      case "yearly":
        startFormat = moment().add(-5, "years").format("YYYY-MM-DD");
        endFormat = "YYYY-MM-DD";
        break;
    }
    if (range) return [moment().format(startFormat), moment().format(endFormat)];
    return moment().format(startFormat);
  }
  calcLimits(date, interval, minus = false) {
    let chosen;
    switch (interval) {
      case "daily":
        let days = Number(moment(date).endOf("month").format("DD")) - 1
        chosen = moment(date).add(minus ? -1 * days : days, "days");
        break;
      case "weekly":
        chosen = moment(date).add(minus ? -1 * 16 : 16, "weeks");
        break;
      case "monthly":
        chosen = moment(date).add(minus ? -1 * 12 : 12, "months");
        break;
      case "yearly":
        chosen = moment(`${date}-01`).add(minus ? -1 * 5 : 5, "years");
    }
    return chosen;
  }
  getEndOfPeriod(interval) {
    let format = "YYYY-MM-DDT23:59:59";
    switch (interval) {
      case "hourly":
        return moment().endOf("month").format(format);
      case "daily":
        return moment().endOf("month").format(format);
      case "weekly":
        return moment().endOf("week").format(format);
      case "monthly":
        return moment().endOf("year").format(format);
      case "yearly":
        return moment().endOf("year").add(5, "years").format(format);
    }
  }
  setMax(date, max, interval, range) {
    if (!date) return;
    let endPedriod = this.getEndOfPeriod(interval);
    let chosenMax = max ? max : endPedriod;
    if (range) {
      if (date.length < 2) {
        let selectedDate = date[0];
        let res = this.calcLimits(selectedDate, interval, false);
        chosenMax = res ? this.setFormat(res, interval) : chosenMax;
      }
    }
    if (max) {
      if (moment(chosenMax).isAfter(max)) chosenMax = max;
    } else {
      if (moment(chosenMax).isAfter(endPedriod)) chosenMax = endPedriod;
    }
    return chosenMax;
  }
  setMin(date, min, interval, range) {
    if (!date) return;
    let firtTime = "1900-01-01";
    let chosenMin = min ? min : firtTime;
    if (range) {
      if (date.length < 2) {
        let selectedDate = date[0];
        let res = this.calcLimits(selectedDate, interval, true);
        chosenMin = res ? this.setFormat(res, interval) : chosenMin;
      }
    }
    if (min) {
      if (moment(chosenMin).isBefore(min)) chosenMin = min;
    } else {
      if (moment(chosenMin).isBefore(firtTime)) chosenMin = firtTime;
    }
    return chosenMin;
  }
  setDate(date, interval, range) {
    if (!date) return;
    if (Array.isArray(date) && date.length >= 2) {
      date = date.sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    }
    if (range && date.length < 2) date[1] = date[0];
    let start = range ? date[0] : date;
    let end = range ? date[1] : date;
    start = moment(start);
    end = moment(end);
    switch (interval) {
      case "hourly":
        start = moment(start).format(`YYYY-MM-DDTHH:mm:ss`);
        end = moment(end).format(`YYYY-MM-DDTHH:mm:ss`);
        break;
      case "daily":
        start = start.startOf("day");
        end = end.endOf("day");
        break;
      case "weekly":
        start = start.startOf("week");
        end = end.endOf("week");
        break;
      case "monthly":
        start = start.startOf("month");
        end = end.endOf("month");
        break;
      case "yearly":
        start = start.startOf("year");
        end = end.endOf("year");
    }
    if (!(interval == "hourly" && range)) {
      start = moment(start).format(`YYYY-MM-DDT00:00:00`);
      end = moment(end).format(`YYYY-MM-DDT23:59:59`);
    }
    if (moment(end).isBefore(start)) return { start: end, end: start };
    return { start, end };
  }

  datetimeString(date, interval, range) {
    let format = "DD/MM/YYYY";
    switch (interval) {
      case "hourly":
        format = "HH:mm:ss";
        break;
      case "weekly":
        format = "DD/MM/YYYY";
        break;
      case "daily":
        format = "DD/MM/YYYY";
        break;
      case "monthly":
        format = "MMM/YYYY";
        break;
      case "yearly":
        format = "YYYY";
    }
    if (range) return `${moment(date.start).format(format)} - ${moment(date.end).format(format)}`;
    else return moment(date).format(format);
  }
  mountResponse(start, end, interval, range) {
    const date = moment(start).format("YYYY-MM-DD");
    const startOfDay = moment(start).format("YYYY-MM-DDT00:00:00");
    const endOfDay = moment(end).format("YYYY-MM-DDT23:59:59");
    const startOfWeek = moment(start).startOf("week").format("YYYY-MM-DDT00:00:00");
    const endOfWeek = moment(end).endOf("week").format("YYYY-MM-DDT23:59:59");
    const startOfMonth = moment(start).format("YYYY-MM-01T00:00:00");
    const endOfMonth = moment(end).endOf("month").format("YYYY-MM-DDT23:59:59");
    const startOfYear = moment(start).format("YYYY-01-01T00:00:00");
    const endOfYear = moment(end).format("YYYY-12-31T23:59:59");
    const response = {
      text: this.datetimeString(range ? { start, end } : date, interval, range),
      date,
      start,
      end,
      startOfDay,
      endOfDay,
      startOfWeek,
      endOfWeek,
      startOfMonth,
      endOfMonth,
      startOfYear,
      endOfYear,
    };
    return response;
  }
}
